import { CiBoxes } from "react-icons/ci";

export const EmptyState = () => {
	return (
		<div className="flex items-center justify-center border-2 border-dashed border-gray-200 rounded-xl py-10 px-6">
			<div className="flex flex-col items-center gap-3 text-center">
				<div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
					<CiBoxes size={26} className="text-gray-400" />
				</div>
				<div>
					<p className="text-sm font-semibold text-gray-600">Nothing here yet</p>
					<p className="text-xs text-gray-400 mt-0.5">Your parcels will appear here once booked.</p>
				</div>
				<a href="/" className="mt-1 text-xs font-semibold text-white bg-violet-600 hover:bg-violet-700 transition-colors px-4 py-2 rounded-full">
					Send a Parcel
				</a>
			</div>
		</div>
	);
};
